import React, { useState, useRef, useEffect } from 'react';
import { dataUserSession } from "../../utilities/dataSession.js";
import { genCiaCameraNameList } from "../../service/CIA/CiaService.js";
import { useHistory } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { normalColumn } from "../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../components/DataTable/ConsBodyStyle.js";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button.js";
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min.js';
import { currentPageReportTemplate, onPageChange, paginatorTemplate } from "../../utilities/TableUtil.js";
import { Loading } from "../../components/Loading/Loading";
import ValidateService from "../../components/ValidateService/ValidateService";
import { Toast } from "primereact/toast";


export default function PCIA() {

    const history = useHistory();
    const [dataList, setDataList] = useState([]);
    const [loading, setLoading] = useState(false);
    const toast = useRef(null);
    const [errData, setErrData] = useState(null);
    const [dialog, setDialog] = useState(false);
    const [data, setData] = useState({});

    const [srcPath, setSrcPath] = useState('');
    const iframeRef = useRef(null);

    const [iframeUrl, setIframeUrl] = useState('');
    let location = useLocation();

    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 })



    const [searchData] = useState({

        userId: dataUserSession() ? dataUserSession().userId : "",
    });

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    useEffect(() => {
        if (!dataUserSession()) {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        onGetDataList();
        // setDataList([
        //     {
        //         "cameraName": "CAM59_SSAA_473121_CAFFB",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM59_SSAA_473121_CAFFB"
        //     },
        //     {
        //         "cameraName": "CAM52_SSAA_473139_DFAAA",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0052/"
        //     },
        //     {
        //         "cameraName": "CAM1_SSAA_499454_EECCC",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0001/"
        //     },
        //     {
        //         "cameraName": "CAM129_SSAH_210824_DFBAF",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0129/"
        //     },
        //     {
        //         "cameraName": "CAM141_SSAK_505947_BFDFC",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0141/"
        //     },
        //     {
        //         "cameraName": "CAM46_SSAA_472877_DDCDD",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0046/"
        //     },
        //     {
        //         "cameraName": "CAM80_SSAA_585602_FECDC",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM80_SSAA_585602_FECDC"
        //     },
        //     {
        //         "cameraName": "CAM99_SSAA_580428_FCEBD",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0099/"
        //     },
        //     {
        //         "cameraName": "CAM51_SSAA_473138_EEAEA",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0051/"
        //     },
        //     {
        //         "cameraName": "CAM138_SSAH_295085_DBFCA",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0138/"
        //     },
        //     {
        //         "cameraName": "CAM47_SSAA_473159_ACFDC",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0047/"
        //     },
        //     {
        //         "cameraName": "CAM43_SSAA_499442_DCECE",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0043/"
        //     },
        //     {
        //         "cameraName": "CAM72_SSAA_585588_BCABB",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM72_SSAA_585588_BCABB"
        //     },
        //     {
        //         "cameraName": "CAM108_SSAA_602004_BEEDF",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM108_SSAA_602004_BEEDF"
        //     },
        //     {
        //         "cameraName": "CAM56_SSAA_465992_FDAFA",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0056/"
        //     },
        //     {
        //         "cameraName": "CAM127_SSAH_295057_ASBBD",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0127/"
        //     },
        //     {
        //         "cameraName": "CAM137_SSAH_295060_ACEAF",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0137/"
        //     },
        //     {
        //         "cameraName": "CAM68_SSAA_585585_ECBDE",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0068/"
        //     },
        //     {
        //         "cameraName": "CAM9_SSAA_499416_FCBAC",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0009/"
        //     },
        //     {
        //         "cameraName": "CAM28_SSAA_498415_FEDCF",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM28_SSAA_498415_FEDCF/"
        //     },
        //     {
        //         "cameraName": "CAM30_SSAA_520278_DBBED",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM30_SSAA_520278_DBBED/"
        //     },
        //     {
        //         "cameraName": "CAM10_SSAA_499472_BCFDC",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0010/"
        //     },
        //     {
        //         "cameraName": "CAM115_SSAA_602007_AEDEB",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM115_SSAA_602007_AEDEB"
        //     },
        //     {
        //         "cameraName": "CAM134_SSAH_295061_FAABE",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0134/"
        //     },
        //     {
        //         "cameraName": "CAM76_SSAA_482879_FBFDF",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0076/"
        //     },
        //     {
        //         "cameraName": "CAM44_SSAA_502528_EBDBD",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0044/"
        //     },
        //     {
        //         "cameraName": "CAM81_SSAA_585586_EDFAA",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0081/"
        //     },
        //     {
        //         "cameraName": "CAM64_SSAA_473155_CDEAA",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0064/"
        //     },
        //     {
        //         "cameraName": "CAM62_SSAA_473167_AAABE",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0062/"
        //     },
        //     {
        //         "cameraName": "CAM54_SSAA_473007_CFFEF",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0054/"
        //     },
        //     {
        //         "cameraName": "CAM82_SSAA_585599_EDBBB",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0082/"
        //     },
        //     {
        //         "cameraName": "CAM78_SSAA_585594_ABAEB",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM78_SSAA_585594_ABAEB"
        //     },
        //     {
        //         "cameraName": "CAM87_SSAA_585587_DFACB",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0087/"
        //     },
        //     {
        //         "cameraName": "CAM117_SSAA_602015_DACBD",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0117/"
        //     },
        //     {
        //         "cameraName": "CAM116_SSAA_602011_EFCAD",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0116/"
        //     },
        //     {
        //         "cameraName": "CAM88_SSAA_585589_ADDFB",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0088/"
        //     },
        //     {
        //         "cameraName": "CAM65_SSAA_585603_FFFAE",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0065/"
        //     },
        //     {
        //         "cameraName": "CAM7_SSAA_499411_EBFEA",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/BR11/CAM7_SSAA_499411_EBFEA/"
        //     },
        //     {
        //         "cameraName": "CAM55_SSAA_473145_DADEA",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0055/"
        //     },
        //     {
        //         "cameraName": "CAM70_SSAA_585591_AFEED",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM70_SSAA_585591_AFEED"
        //     },
        //     {
        //         "cameraName": "CAM48_SSAA_473183_FAEFB",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0048/"
        //     },
        //     {
        //         "cameraName": "CAM100_SSAA_580431_FABAC",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM100_SSAA_580431_FABAC"
        //     },
        //     {
        //         "cameraName": "CAM142_SSAK_505946_DFCFC",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0142/"
        //     },
        //     {
        //         "cameraName": "CAM132_SSAH_295065_EBEAB",
        //         "cameraUrl": " https://cia-bigdata.mwa.co.th/ciacam/CAM0132/"
        //     },
        //     {
        //         "cameraName": "CAM131_SSAH_295056_FBFCC",
        //         "cameraUrl": " https://cia-bigdata.mwa.co.th/ciacam/CAM0131/"
        //     },
        //     {
        //         "cameraName": "CAM6_SSAA_499491_DDCFB",
        //         "cameraUrl": " https://cia-bigdata.mwa.co.th/ciacam/CAM0006/"
        //     },
        //     {
        //         "cameraName": "CAM5_SSAA_499464_DAABA",
        //         "cameraUrl": " https://cia-bigdata.mwa.co.th/ciacam/CAM0005/"
        //     },
        //     {
        //         "cameraName": "CAM53_SSAA_473206_FCABC",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0053/"
        //     },
        //     {
        //         "cameraName": "CAM94_SSAA_580456_BBDCF",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0094/"
        //     },
        //     {
        //         "cameraName": "CAM26_SSAA_498406_EDEDB",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM26_SSAA_498406_EDEDB/"
        //     },
        //     {
        //         "cameraName": "CAM89_SSAA_580423_DFEFB",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0089/"
        //     },
        //     {
        //         "cameraName": "CAM2_SSAA_499426_BDCBD",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0002/"
        //     },
        //     {
        //         "cameraName": "CAM66_SSAA_585592_ACBCF",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0066/"
        //     },
        //     {
        //         "cameraName": "CAM122_SSHA_295087_DEBBA",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0122/"
        //     },
        //     {
        //         "cameraName": "CAM111_SSAA_602013_FCAEA",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0111/"
        //     },
        //     {
        //         "cameraName": "CAM63_SSAA_473132_CCDAD",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0063/"
        //     },
        //     {
        //         "cameraName": "CAM77_SSAA_585593_DDCCE",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0077/"
        //     },
        //     {
        //         "cameraName": "CAM140_SSAK_505917_FBBBF",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0140"
        //     },
        //     {
        //         "cameraName": "CAM139_SSAK_519307_CCCBD",
        //         "cameraUrl": "https://cia-bigdata.mwa.co.th/ciacam/CAM0139/"
        //     },
        //     {
        //         "cameraName": "CAM57_SSAA_473207_BBCBE",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM57_SSAA_473207_BBCBE"
        //     },
        //     {
        //         "cameraName": "CAM23_SSAA_498398_CADFF",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM23_SSAA_498398_CADFF/"
        //     },
        //     {
        //         "cameraName": "CAM107_SSAA_602006_DCAED",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM107_SSAA_602006_DCAED"
        //     },
        //     {
        //         "cameraName": "CAM8_SSAA_499479_ABFEA",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/BR11/CAM8_SSAA_499479_ABFEA/"
        //     },
        //     {
        //         "cameraName": "CAM25_SSAA_520289_BBADB",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM25_SSAA_520289_BBADB/"
        //     },
        //     {
        //         "cameraName": "CAM124_SSAH_295074_FCBEC",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM124_SSAH_295074_FCBEC"
        //     },
        //     {
        //         "cameraName": "CAM97_SSAA_580445_ADEBF",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM97_SSAA_580445_ADEBF"
        //     },
        //     {
        //         "cameraName": "CAM133_SSAH_295048_BCDAD",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM133_SSAH_295048_BCDAD"
        //     },
        //     {
        //         "cameraName": "CAM49_SSAA_473180_BCABD",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM49_SSAA_473180_BCABD"
        //     },
        //     {
        //         "cameraName": "CAM27_SSAA_498378_EDEDA",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM27_SSAA_498378_EDEDA/"
        //     },
        //     {
        //         "cameraName": "CAM19_SSAA_498283_CFBAD",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/BR11/CAM19_SSAA_498283_CFBAD/"
        //     },
        //     {
        //         "cameraName": "CAM75_SSAA_585590_FFEAD",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM75_SSAA_585590_FFEAD"
        //     },
        //     {
        //         "cameraName": "CAM29_SSAA_474406_EDEBA",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM29_SSAA_474406_EDEBA/"
        //     },
        //     {
        //         "cameraName": "CAM118_SSAA_599999_FDDED",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM118_SSAA_599999_FDDED"
        //     },
        //     {
        //         "cameraName": "CAM120_SSAA_599993_BEEDB",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM120_SSAA_599993_BEEDB"
        //     },
        //     {
        //         "cameraName": "CAM93_SSAA_580448_BDDCF",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM93_SSAA_580448_BDDCF"
        //     },
        //     {
        //         "cameraName": "CAM67_SSAA_482876_EBBBB",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM67_SSAA_482876_EBBBB"
        //     },
        //     {
        //         "cameraName": "CAM38_SSAA_502548_EEFDA",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM38_SSAA_502548_EEFDA/"
        //     },
        //     {
        //         "cameraName": "CAM37_SSAA_502310_FFFFE",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM37_SSAA_502310_FFFFE/"
        //     },
        //     {
        //         "cameraName": "CAM103_SSAA_599997_BFEAE",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM103_SSAA_599997_BFEAE"
        //     },
        //     {
        //         "cameraName": "CAM119_SSAA_602003_CAAAF",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM119_SSAA_602003_CAAAF"
        //     },
        //     {
        //         "cameraName": "CAM12_SSAA_499432_DBDBD",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/BR11/CAM12_SSAA_499432_DBDBD/"
        //     },
        //     {
        //         "cameraName": "CAM136_SSAH_295079_AFCFB",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM136_SSAH_295079_AFCFB"
        //     },
        //     {
        //         "cameraName": "CAM125_SSAH_295071_CAADB",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM125_SSAH_295071_CAADB"
        //     },
        //     {
        //         "cameraName": "CAM50_SSAA_473153_FFFCC",
        //         "cameraUrl": null
        //     },
        //     {
        //         "cameraName": "CAM91_SSAA_482896_ABEED",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM91_SSAA_482896_ABEED"
        //     },
        //     {
        //         "cameraName": "CAM15_SSAA_499458_FEEED",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/BR11/CAM15_SSAA_499458_FEEED/"
        //     },
        //     {
        //         "cameraName": "CAM84_SSAA_585598_DBFFA",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM84_SSAA_585598_DBFFA"
        //     },
        //     {
        //         "cameraName": "CAM17_SSAA_499469_CEBDF",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/BR11/CAM17_SSAA_499469_CEBDF/"
        //     },
        //     {
        //         "cameraName": "CAM90_SSAA_580426_FCFEC",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM90_SSAA_580426_FCFEC"
        //     },
        //     {
        //         "cameraName": "CAM71_SSAA_585601_DFEFB",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM71_SSAA_585601_DFEFB"
        //     },
        //     {
        //         "cameraName": "CAM104_SSAA_602014_FCBAA",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM104_SSAA_602014_FCBAA"
        //     },
        //     {
        //         "cameraName": "CAM11_SSAA_498145_BDEFA",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/BR11/CAM11_SSAA_498145_BDEFA"
        //     },
        //     {
        //         "cameraName": "CAM121_SSHA_295062_EDFAE",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM121_SSAH_295062_EDFAE"
        //     },
        //     {
        //         "cameraName": "CAM92_SSAA_580440_CAFCB",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM92_SSAA_580440_CAFCB"
        //     },
        //     {
        //         "cameraName": "CAM20_SSAA_499400_DDABE",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/BR11/CAM20_SSAA_499400_DDABE/"
        //     },
        //     {
        //         "cameraName": "CAM113_SSAA_602002_EEDDA",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM113_SSAA_602002_EEDDA"
        //     },
        //     {
        //         "cameraName": "CAM73_SSAA_482901_DBABA",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM73_SSAA_482901_DBABA"
        //     },
        //     {
        //         "cameraName": "CAM106_SSAA_699995_DABBF",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM106_SSAA_699995_DABBF"
        //     },
        //     {
        //         "cameraName": "CAM105_SSAA_602001_EBCDA",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM105_SSAA_602001_EBCDA"
        //     },
        //     {
        //         "cameraName": "CAM58_SSAA_473122_AFAAC",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM58_SSAA_473122_AFAAC"
        //     },
        //     {
        //         "cameraName": "CAM4_SSAA_040190_BFCCB",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/BR11/CAM4_SSAA_040190_BFCCB/"
        //     },
        //     {
        //         "cameraName": "CAM83_SSAA_585604_FBDBB",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM83_SSAA_585604_FBDBB"
        //     },
        //     {
        //         "cameraName": "CAM42_SSAA_502665_CBABE",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM42_SSAA_502665_CBABE/"
        //     },
        //     {
        //         "cameraName": "CAM130_SSAH_295081_EBCCC",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM130_SSAH_295081_EBCCC"
        //     },
        //     {
        //         "cameraName": "CAM86_SSAA_585596_EDBEC",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM86_SSAA_585596_EDBEC"
        //     },
        //     {
        //         "cameraName": "CAM135_SSAH_295051_DDADE",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM135_SSAH_295051_DDADE"
        //     },
        //     {
        //         "cameraName": "CAM96_SSAA_580465_AFCEC2",
        //         "cameraUrl": " http://110.78.219.103/CIA_IMAGE_HIS/CAM96_SSAA_580465_AFCEC2"
        //     },
        //     {
        //         "cameraName": "CAM112_SSAA_602016_FCEAE",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM112_SSAA_602016_FCEAE"
        //     },
        //     {
        //         "cameraName": "CAM101_SSAA_580468_FFCDA",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM101_SSAA_580468_FFCDA"
        //     },
        //     {
        //         "cameraName": "CAM126_SSAH_295084_CFFCA",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM126_SSAH_295084_CFFCA"
        //     },
        //     {
        //         "cameraName": "CAM95_SSAA_580421_CBBEB",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM95_SSAA_580421_CBBEB"
        //     },
        //     {
        //         "cameraName": "CAM61_SSAA_473134_CEEBB",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM61_SSAA_473134_CEEBB"
        //     },
        //     {
        //         "cameraName": "CAM102_SSAA_580441_FEDAC",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM102_SSAA_580441_FEDAC"
        //     },
        //     {
        //         "cameraName": "CAM128_SSAH_295050_DEFBA",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM128_SSAH_295050_DEFBA"
        //     },
        //     {
        //         "cameraName": "CAM110_SSAA_602012_DFDFA",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM110_SSAA_602012_DFDFA"
        //     },
        //     {
        //         "cameraName": "CAM60_SSAA_472978_EFDCB",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM60_SSAA_472978_EFDCB"
        //     },
        //     {
        //         "cameraName": "CAM85_SSAA_585597_CDEDD",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM85_SSAA_585597_CDEDD"
        //     },
        //     {
        //         "cameraName": "CAM34_SSAA_502690_FCAAD",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM34_SSAA_502690_FCAAD/"
        //     },
        //     {
        //         "cameraName": "CAM13_SSAA_499591_CDDEA",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/BR11/CAM13_SSAA_499591_CDDEA/"
        //     },
        //     {
        //         "cameraName": "CAM41_SSAA_502555_DEAAE",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM41_SSAA_502555_DEAAE/"
        //     },
        //     {
        //         "cameraName": "CAM123_SSAH_295058_FFCAE",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM123_SSAH_295058_FFCAE"
        //     },
        //     {
        //         "cameraName": "CAM_SSAH_295071_CAADB",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM_SSAH_295071_CAADB"
        //     },
        //     {
        //         "cameraName": "CAM79_SSAA_585595_DDFEB",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM79_SSAA_585595_DDFEB"
        //     },
        //     {
        //         "cameraName": "CAM109_SSAA_599992_DDFAA",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM109_SSAA_599992_DDFAA"
        //     },
        //     {
        //         "cameraName": "CAM16_SSAA_499461_ABBFF",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/BR11/CAM16_SSAA_499461_ABBFF/"
        //     },
        //     {
        //         "cameraName": "CAM74_SSAA_482910_DBCCF",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM74_SSAA_482910_DBCCF"
        //     },
        //     {
        //         "cameraName": "CAM114_SSAA_602018_BECEE",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM114_SSAA_602018_BECEE"
        //     },
        //     {
        //         "cameraName": "CAM69_SSAA_585600_EFACE",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM69_SSAA_585600_EFACE"
        //     },
        //     {
        //         "cameraName": "CAM98_SSAA_580432_CBDCB",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM98_SSAA_580432_CBDCB"
        //     },
        //     {
        //         "cameraName": "CAM24_SSAA_520265_ADBFD",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM24_SSAA_520265_ADBFD/"
        //     },
        //     {
        //         "cameraName": "CAM39_SSAA_502695_BAFCA",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM39_SSAA_502695_BAFCA/"
        //     },
        //     {
        //         "cameraName": "CAM33_SSAA_502677_FAEEC",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM33_SSAA_502677_FAEEC"
        //     },
        //     {
        //         "cameraName": "CAM31_SSAA_502667_FBDDB",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM31_SSAA_502667_FBDDB/"
        //     },
        //     {
        //         "cameraName": "CAM40_SSAA_502663_DAFBF",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM40_SSAA_502663_DAFBF"
        //     },
        //     {
        //         "cameraName": "CAM36_SSAA_502659_FACFB",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM36_SSAA_502659_FACFB/"
        //     },
        //     {
        //         "cameraName": "CAM35_SSAA_502539_CBBFB",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM35_SSAA_502539_CBBFB"
        //     },
        //     {
        //         "cameraName": "CAM32_SSAA_502523_BFEAB",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM32_SSAA_502523_BFEAB/"
        //     },
        //     {
        //         "cameraName": "CAM3_SSAA_499535_EBEEC",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/BR11/CAM3_SSAA_499535_EBEEC/"
        //     },
        //     {
        //         "cameraName": "CAM14_SSAA_499474_FFDAA",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/BR11/CAM14_SSAA_499474_FFDAA/"
        //     },
        //     {
        //         "cameraName": "CAM22_SSAA_498410_AAADF",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM22_SSAA_498410_AAADF/"
        //     },
        //     {
        //         "cameraName": "CAM21_SSAA_474402_CCDEF",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM21_SSAA_474402_CCDEF/"
        //     },
        //     {
        //         "cameraName": "CAM48_SSAA_483313_BFBAA",
        //         "cameraUrl": null
        //     },
        //     {
        //         "cameraName": "CAM45_SSAA_502689_BABFF",
        //         "cameraUrl": "http://110.78.219.103/CIA_IMAGE_HIS/CAM45_SSAA_502689_BABFF"
        //     }
        // ])
    }, [searchData]);

    useEffect(() => {
        const handleIframeMessage = (event) => {
            //   if (event.origin !== window.location.origin) {
            //     // ตรวจสอบว่า origin ตรงกันเพื่อความปลอดภัย
            //     return;
            //   }
            const { url } = event.data;
            if (url) {
                console.log('URL inside iframe changed to:', url);
            }
        };

        window.addEventListener('message', handleIframeMessage);

        return () => {
            window.removeEventListener('message', handleIframeMessage);
        };
    }, []);

    useEffect(() => {

        console.log('iframe:', iframeRef);
        if (iframeRef.current) {
            const currentUrl = iframeRef.current.contentWindow.location.href;
            console.log('Current URL in iframe:', currentUrl);
        }

        console.log("location", location);

    }, [location]);

    // useEffect(() => {
    //     const checkIframeUrl = () => {
    //       if (iframeRef.current) {
    //         console.log("location : ",iframeRef.current.contentWindow);

    //         console.log("document : ", iframeRef.current.contentWindow.document.getElementsByTagName("a"));

    //         const currentUrl = iframeRef.current.contentWindow.location.href;

    //         // eventer(messageEvent, function (e) {
    //         //     // replay to child (iframe) 
    //         //     document.getElementById('wrapper-iframe').contentWindow.postMessage(
    //         //         {
    //         //             event_id: 'white_label_message',
    //         //             wl: {
    //         //                 header_bg: $('#Header').css('background-color'),
    //         //                 header_text: $('#Header .HoverMenu a').css('color'),
    //         //                 button_bg: $('#Header .HoverMenu a').css('background-color')
    //         //             }
    //         //         },
    //         //         '*'
    //         //     );
    //         // }, false);


    //         if (currentUrl !== iframeUrl) {
    //           setIframeUrl(currentUrl);
    //         }
    //       }
    //     };

    //     const intervalId = setInterval(checkIframeUrl, 1000);

    //     return () => {
    //       clearInterval(intervalId);
    //     };
    //   }, [iframeUrl]);
    // useEffect(() => {
    //     // Initial src path
    //     //const initialSrc = 'https://cdn.discordapp.com/attachments/1122924206284361874/1187659509263511562/Screenshot_20231222_143431_PWA_Field_ServiceUAT.jpg?ex=667332dc&is=6671e15c&hm=d0fec33ae975655afe435889edb38cb34ef8bcacc9e7de3e219c0a08d39c7f96&';
    //     setSrcPath(data.cameraUrl);
    //   }, [data.cameraUrl]);

    //   useEffect(() => {
    //     const iframeElement = iframeRef.current;

    //     const handleSrcChange = () => {
    //       if (iframeElement) {
    //         const newSrc = iframeElement.src;
    //         setSrcPath(newSrc);
    //         console.log("Current src:", newSrc);
    //       }
    //     };

    //     // Create a MutationObserver to detect changes in the src attribute
    //     const observer = new MutationObserver(handleSrcChange);

    //     if (iframeElement) {
    //       observer.observe(iframeElement, { attributes: true, attributeFilter: ['src'] });
    //     }

    //     // Clean up the observer
    //     return () => {
    //       if (observer && iframeElement) {
    //         observer.disconnect();
    //       }
    //     };
    //   }, [iframeRef]);


    //   console.log('srcPath',srcPath)

    const onGetDataList = async () => {
        setLoading(true);
        let req = {
            userId: searchData.userId,
        };

        await genCiaCameraNameList().then(
            (res) => {
                setLoading(false);
                console.log("dataList : ", res.dataList)
                if (res.dataList !== undefined) {

                    let temp = [];
                    let index = 1;
                    res.dataList.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataList(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const actionEditColumn = (rowData, action) => {
        let labelShow = <span className="show-responsive">แก้ไขข้อมูล</span>;
        return (
            <React.Fragment>
                <div style={{ textAlign: "center" }}>
                    {/* <Button icon="pi pi-pencil" className="p-button p-button-warning btn-label-responsive btn-md-responsive" onClick={() => action(rowData)} tooltip="คลิกเพื่อ แก้ไข" tooltipOptions={{ position: "top" }} label={labelShow} /> */}
                    <Button

                        icon="pi pi-folder"
                        className="p-button  btn-label-responsive btn-md-responsive"
                        onClick={() => openDialog(rowData)}
                        tooltip="คลิกเพื่อ แก้ไข"
                        tooltipOptions={{ position: "top" }}
                        label={labelShow}
                    />
                </div>
            </React.Fragment>
        );
    };

    const openDialog = (rowData) => {
        setDialog(true);
        setData(rowData);

    }

    //     useEffect(() => {
    //         const iframe = iframeRef.current;

    //         if (iframe) {
    //           const getIframeUrl = () => {
    //             // ดึง URL ที่ตั้งค่าไว้
    //             const initialUrl = iframe.src;
    //             console.log('Initial URL:', initialUrl);

    //             // ดึง URL ปัจจุบันที่ iframe นำมาแสดง
    //             const currentUrl = iframe.contentWindow.location.href;
    //             console.log('Current URL:', currentUrl);
    //           };

    //           // เรียกใช้ getIframeUrl หลังจาก iframe โหลดเสร็จแล้ว
    //           iframe.onload = getIframeUrl;
    //         }
    //       }, []); // เพิ่ม dependency array เพื่อให้ effect ทำงานเมื่อ data.cameraUrl เปลี่ยน
    // console.log("iframeRef.current",iframeRef.current);
    const dialogDocument = () => {

        return (
            <>

                <Dialog
                    // header={"PDF"}
                    visible={dialog}
                    style={{ width: "90vw" }}
                    onHide={() => setDialog(false)}
                    blockScroll
                    className="p-fluid"
                    maximizable
                // maximized
                >
                    <div className="p-fluid p-formgrid p-grid">
                        {/* <button 
                    // onclick="javascrip t:history.back( )"
                    >BACK</button>
                    <button 
                    // onclick="window.history.forward()"
                    >FORWARD</button>
                    <p>Current iframe URL: {iframeUrl}</p> */}
                        <iframe
                            ref={iframeRef}
                            src={data.cameraUrl}
                            width="100%" height="800px"></iframe>
                    </div>
                </Dialog>
            </>
        );
    }


    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />


                <div className="p-col-12">
                    <div className="card">
                        <div className="p-grid  p-fluid">
                            <div className="p-field p-col-12 p-md-6">
                                <Button
                                    className="p-button-secondary p-button btn-long-top-responsive"
                                    icon="pi pi-arrow-left"
                                    label="กลับหน้าจอหลัก"
                                    // style={{ display: 'flex',marginBottom : '10px' }}
                                    style={{ width: 170, marginLeft: "5px" }}
                                    onClick={() => {
                                        history.push("/400");
                                    }}
                                />
                            </div>

                        </div>
                        <DataTable
                            // ref={(el) => dt = el}
                            value={dataList}
                            dataKey="id"
                            paginator
                            first={pageConf.first}
                            rows={pageConf.rows}
                            onPage={(e) => onPageChange(e, setPageConf)}
                            rowsPerPageOptions={[5, 10, 25]}
                            paginatorTemplate={paginatorTemplate()}
                            currentPageReportTemplate={currentPageReportTemplate()}
                            //header={header}
                            // globalFilter={globalFilter}
                            emptyMessage="ไม่พบข้อมูล"
                            className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                            selectionMode="single"
                        >

                            <Column field="cameraName" header="ชื่อกล้อง" body={(e) => normalColumn(e, "cameraName", "")} sortable style={{ textAlign: "center", width: "15%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER_SPACE} />
                            <Column field="cameraUrl" header="URL" body={(e) => normalColumn(e, "cameraUrl", "")} sortable style={{ textAlign: "center", width: "15%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER_SPACE} />
                            <Column header="" field="photoPath" body={(e) => actionEditColumn(e)} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER}></Column>
                        </DataTable>
                    </div>
                </div>
                {dialogDocument()}

            </div>

        </>

    )

};